import { addMessages } from '@hana/i18n';

// Khoá chuỗi của ngăn Hồ sơ tàu (VesselDrawer.tsx). Nội dung việc cần làm, dự báo, cut-off, lịch sử, tên nguồn (vessel.ts · vesselForecast.ts) và dữ liệu mẫu không dịch.
addMessages('vi', {
  'vd.kChg': 'Đổi lịch',
  'vd.kNew': 'Tạo',
  'vd.fold': 'Mở hoặc gập {v}',
  'vd.noWrite': 'Chưa mở ghi ở bản này',
  'vd.ais': 'Vị trí AIS',
  'vd.mapAria': 'Bản đồ vị trí {name} · {sog} → Cái Mép',
  'vd.caiMep': 'Cái Mép',
  'vd.pos': 'Toạ độ',
  'vd.speed': 'Tốc độ · hướng',
  'vd.status': 'Trạng thái',
  'vd.dist': 'Cách cảng tới',
  'vd.updated': 'Cập nhật',
  'vd.fcTitle': 'Dự báo ETA / ETB / ETD · {v}',
  'vd.recalcAsked': 'Đã yêu cầu tính lại',
  'vd.recalcing': 'Đang tính lại',
  'vd.recalc': 'Tính lại ngay',
  'vd.sysPick': 'Hệ thống chọn · {v}',
  'vd.predEtb': 'Dự đoán ETB',
  'vd.predEtd': 'Dự đoán ETD',
  'vd.conf': 'Độ tin cậy',
  'vd.bySrc': 'Theo nguồn · lệch so lịch hãng {v}',
  'vd.chosen': 'Được chọn',
  'vd.upd': 'cập nhật {v}',
  'vd.confN': 'tin cậy {n}%',
  'vd.scans': 'Dự đoán qua các lần quét',
  'vd.scansN': '{n} lần quét',
  'vd.scanAria': 'Lệch ETD dự đoán so lịch qua {n} lần quét',
  'vd.viewBk': 'Xem booking',
  'vd.notifyCust': 'Báo khách',
  'vd.todo': 'Việc cần làm',
  'vd.voyStatus': 'Trạng thái chuyến',
  'vd.left': 'Đã rời {v}',
  'vd.heading': 'Đang tới {v}',
  'vd.sailed': 'Đã chạy',
  'vd.notSailed': 'Chưa chạy',
  'vd.prevPort': 'Cảng trước {v}',
  'vd.cutoffs': 'Mốc cut-off',
  'vd.voyage': 'Chuyến {v}',
  'vd.edit': 'Sửa',
  'vd.shipLine': 'Hãng tàu',
  'vd.noticeType': 'Loại notice',
  'vd.changeCount': 'Số lần đổi lịch',
  'vd.ident': 'Nhận dạng tàu',
  'vd.editProfile': 'Sửa hồ sơ',
  'vd.flag': 'Cờ',
  'vd.shipType': 'Loại tàu',
  'vd.lxw': 'Dài × rộng',
  'vd.draught': 'Mớn nước tối đa',
  'vd.noImo': 'Tàu chưa có hồ sơ IMO — thêm ở Giá & lịch tàu › Hồ sơ tàu để theo dõi AIS.',
  'vd.noRot': 'Chưa có hải trình',
  'vd.noRotD': 'Chưa có rotation của service cho chuyến này.',
  'vd.itinerary': 'Hải trình',
  'vd.stLeft': 'Đã rời',
  'vd.stNext': 'Đang tới',
  'vd.stPlan': 'Dự kiến',
  'vd.bkN': '{n} booking',
  'vd.hCust': 'Khách',
  'vd.hReturn': 'Hạ full',
  'vd.hLate': 'Báo trễ',
  'vd.not': 'Chưa',
  'vd.noBk': 'Chưa có booking trên chuyến',
  'vd.filterBk': 'Lọc booking',
  'vd.all': 'Tất cả',
  'vd.bkOnVoy': 'Booking trên chuyến',
  'vd.filterHist': 'Lọc lịch sử',
  'vd.noChange': 'Chưa có thay đổi',
  'vd.noFiles': 'Chưa có tệp notice',
  'vd.files': 'Tệp notice',
  'vd.askNotice': 'Ask HANA đọc notice',
  'vd.sendNotice': 'Gửi notice',
  'vd.moreActions': 'Thêm thao tác',
  'vd.changedN': 'Đổi lịch {n} lần',
  'vd.sections': 'Mục hồ sơ tàu',
  'vd.tOv': 'Tổng quan',
  'vd.tRot': 'Lịch & cảng ghé',
  'vd.tHist': 'Lịch sử',
  'vd.tDocs': 'Tài liệu',
  'vd.close': 'Đóng hồ sơ tàu (Esc)',
});
addMessages('en', {
  'vd.kChg': 'Schedule change',
  'vd.kNew': 'Created',
  'vd.fold': 'Expand or collapse {v}',
  'vd.noWrite': 'Writing is not enabled in this version',
  'vd.ais': 'AIS position',
  'vd.mapAria': 'Position map of {name} · {sog} → Cai Mep',
  'vd.caiMep': 'Cai Mep',
  'vd.pos': 'Coordinates',
  'vd.speed': 'Speed · heading',
  'vd.status': 'Status',
  'vd.dist': 'Distance to port',
  'vd.updated': 'Updated',
  'vd.fcTitle': 'ETA / ETB / ETD forecast · {v}',
  'vd.recalcAsked': 'Recalculation requested',
  'vd.recalcing': 'Recalculating',
  'vd.recalc': 'Recalculate now',
  'vd.sysPick': 'System pick · {v}',
  'vd.predEtb': 'Predicted ETB',
  'vd.predEtd': 'Predicted ETD',
  'vd.conf': 'Confidence',
  'vd.bySrc': 'By source · offset vs carrier schedule {v}',
  'vd.chosen': 'Selected',
  'vd.upd': 'updated {v}',
  'vd.confN': 'confidence {n}%',
  'vd.scans': 'Prediction across scans',
  'vd.scansN': '{n} scans',
  'vd.scanAria': 'Predicted ETD offset vs schedule across {n} scans',
  'vd.viewBk': 'View bookings',
  'vd.notifyCust': 'Notify customers',
  'vd.todo': 'To do',
  'vd.voyStatus': 'Voyage status',
  'vd.left': 'Left {v}',
  'vd.heading': 'Heading to {v}',
  'vd.sailed': 'Sailed',
  'vd.notSailed': 'Not sailed',
  'vd.prevPort': 'Previous port {v}',
  'vd.cutoffs': 'Cut-off times',
  'vd.voyage': 'Voyage {v}',
  'vd.edit': 'Edit',
  'vd.shipLine': 'Shipping line',
  'vd.noticeType': 'Notice type',
  'vd.changeCount': 'Schedule changes',
  'vd.ident': 'Vessel identity',
  'vd.editProfile': 'Edit profile',
  'vd.flag': 'Flag',
  'vd.shipType': 'Vessel type',
  'vd.lxw': 'Length × beam',
  'vd.draught': 'Max draught',
  'vd.noImo': 'This vessel has no IMO profile — add it under Rates & Schedules › Vessel profiles to track AIS.',
  'vd.noRot': 'No itinerary yet',
  'vd.noRotD': 'No service rotation for this voyage yet.',
  'vd.itinerary': 'Itinerary',
  'vd.stLeft': 'Departed',
  'vd.stNext': 'Arriving',
  'vd.stPlan': 'Planned',
  'vd.bkN': '{n} bookings',
  'vd.hCust': 'Customer',
  'vd.hReturn': 'Full return',
  'vd.hLate': 'Delay notice',
  'vd.not': 'Not yet',
  'vd.noBk': 'No bookings on this voyage',
  'vd.filterBk': 'Filter bookings',
  'vd.all': 'All',
  'vd.bkOnVoy': 'Bookings on voyage',
  'vd.filterHist': 'Filter history',
  'vd.noChange': 'No changes yet',
  'vd.noFiles': 'No notice files yet',
  'vd.files': 'Notice files',
  'vd.askNotice': 'Ask HANA reads notice',
  'vd.sendNotice': 'Send notice',
  'vd.moreActions': 'More actions',
  'vd.changedN': 'Schedule changed {n} times',
  'vd.sections': 'Vessel profile sections',
  'vd.tOv': 'Overview',
  'vd.tRot': 'Schedule & ports of call',
  'vd.tHist': 'History',
  'vd.tDocs': 'Documents',
  'vd.close': 'Close vessel profile (Esc)',
});
